import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableV3ContainerLabelShipments = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enableV3ContainerLabelShipments);
};
